import { Empty, MortarboardLineIcon } from 'ui';
import { useDebounce } from 'common/hooks';
import { EntityList } from 'features/channels';
import { useProgramsInfiniteQuery } from 'features/programs';

type P = {
  getPathToProgramDetail: (id: string) => string;
  memberId: string;
  search?: string;
};

const MemberProgramsList = ({ getPathToProgramDetail, memberId, search: propertySearch }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const {
    data: allProgramsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useProgramsInfiniteQuery({
    filter: { scope: 'joined', search, userId: memberId },
    pagination: { pageSize: 12 },
  });

  const allPrograms = allProgramsData?.pages.flat().flatMap((programsPaginated) => programsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no programs to display here',
            title: 'No programs',
          }}
          image={<MortarboardLineIcon />}
        />
      }
      entities={allPrograms?.map((program) => ({
        data: program,
        type: 'Program',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToProgramDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll || isDebouncing}
    />
  );
};

export default MemberProgramsList;
